import { render, staticRenderFns } from "./BaseTableRow.vue?vue&type=template&id=9079dfa0&scoped=true&"
import script from "./BaseTableRow.vue?vue&type=script&lang=js&"
export * from "./BaseTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9079dfa0",
  null
  
)

export default component.exports